// extracted by mini-css-extract-plugin
var _1 = "GretaAIChatCodeBlock-modulecodeBlock__JUw6b";
var _2 = "GretaAIChatCodeBlock-modulecopyButton__jA2PI GretaAIChatIconButton-moduleiconButton__vHrJi";
var _3 = "GretaAIChatCodeBlock-modulepre__s7YB_";
export { _1 as "codeBlock", _2 as "copyButton", _3 as "pre" }
